export const ACCOUNT_TO_CURRENCY = {
  "Chase Sapphire Reserve": "USD",
  "Citi Credit Card": "USD",
  "Schwab Checking": "USD",
  "BoA Credit Card": "USD",
  "BoA Checking": "USD",
  "Tangerine Credit Card": "CAD",
  "Tangerine Checking": "CAD"
};

export const MONTHLY_SPEND_GOAL = 500;
export const YEARLY_SAVINGS_GOAL = 25000;
export const YEARLY_CHARITY_GOAL = 2000;
